/**
* @name: index
* @author: weiyong
* @date: 2022-10-26 22:14
* @description：index
* @update: 2022-10-26 22:14
*/
<template>
  <span class="xmImportDataBtn xm-btn"
        v-if="vuex['showCtl']!==false&&roleAclDisplayFlag"
        :style="{...(props.remarkWidth ? {'--remarkWidth': props.remarkWidth + 'px'} : {}), ...(props.backgroundColor ? {'--bgColor': props.backgroundColor} : {}), ...elCtlStyle}"
  >
      <xm-button :data-label="(props&&props.label)"
                 :props="props"
                 :btnLabel="roleAclLabel"
                 :showLabel="false"
                 style="cursor: pointer;"
                 pItem="xmImportDataBtn"
                 :styles="styles"
                 :model="model"
                 :size="size"
                 :disabledBtnAcl="roleAclDisabledFlag"
                 @clickBtn="openImportWin"
                 :events="events"
                 :id="props.key"
      >
    </xm-button>
    <!-- 旧模式导入弹窗 -->
    <import-win-modal v-if="!props.newMode"
                      @closeWin="closeWin"
                      :props="props"
                      :params="params"
                      window-title="导入数据"
                      ref="importWinRef"
                      :windowHeight="props.windowHeight"
                      :windowWidth="props.windowWidth"
                      v-model:visible="winVisible"/>

    <!-- 新模式导入弹窗 -->
    <new-import-modal v-else
                      @closeWin="closeWin"
                      @refresh="handleRefresh"
                      :props="props"
                      :params="params"
                      window-title="导入数据"
                      ref="newImportWinRef"
                      v-model:visible="winVisible"/>
  </span>

</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "xmImportDataBtnCtl",
});
</script>

<script lang="ts" setup>
import XmButton from "@/main-page-base/ctls/baseCtls/xmButton/index.vue";
import {useCtlStyle} from "@/main-page/hooks/useCtlStyle";
import {useComEvent} from "@/main-page/ctls/hooks/useComEvent";
import {initPropDefValues} from "@/utils";
import ImportWinModal from "@/main-page/components/import-win-modal.vue";
import NewImportModal from "@/main-page/components/new-import-modal.vue";
import {useVuexState} from "@/main-page/ctls/hooks/useVuexState";
import {usePageRoleAcl} from "@/main-page/ctls/hooks/usePageRoleAcl";
import {CtlComEnum} from "@/main-page/enums/ctlComEnum";
import {deepClone} from "xmgoing-utils";
import { getParamsRelVal} from "@/main-page/utils/domainQueryUtils";
import {usePageModelsStore} from "@/store/modules/pageModels";

const pageModelsStore = usePageModelsStore();
interface propTypes {
  size:any;
  elConfig: any,
  props: any,
  pItem:string,
  events: any,
  styles: any,
  model: any,
  pModelObj: any;
}

const propsPage = withDefaults(defineProps<propTypes>(), {
  elConfig: {},
  styles: {},
  size:'',
  pItem:'',
  events: [],
  props: {},
  model: {},
  pModelObj: {},
})
const {props, styles, pItem, model, events}: any = toRefs(propsPage);
initPropDefValues({
  pItem:propsPage.pItem,
  hasTempData:true,
  importParams:[],
  windowWidth:800,
  windowHeight:550,
  clearRepeatFlag:false,
  showCtl: true,
  newMode: false,
  supportUpdate: false,
}, props);
if((unref(props).windowWidth+'').indexOf("%")>0){
  unref(props).windowWidth=document.body.clientWidth*(parseFloat(unref(props).windowWidth)/100);
}

const emits=defineEmits(['clickBtn','closeWin']);
const importWinRef=ref<any>(null);

const closeWin=function ({flush, records}){
  if(!unref(props).newMode){
    importWinRef.value?.clearImpState();
  }
  emits('closeWin',{flush, records});
  clickEvent('closeWin', {});
}

const handleRefresh=function (){
  clickEvent('refresh', {});
}
//导入去重设置
const params=ref({});

const getParam = ()=>{
  //组装用户定义的查询参数
  const queryParamsDs:any = deepClone(unref(props).importParams);
  if (queryParamsDs && Array.isArray(queryParamsDs)) {
    queryParamsDs.forEach((itemDb) => {
      const {filterValue, paraName, filterSubValue, valueType,condition,flowParams} = itemDb;
      const relValue = getParamsRelVal({
        paramValType: valueType,
        paramVal: filterValue,
        varSubParam: filterSubValue,
        pageModelsStore
      });
      params.value = {
        ...unref(params),
        [paraName]:relValue
      }
    })
  }
}
watch(pageModelsStore,()=>{
  getParam()
}, {deep: true})
getParam()
initPropDefValues({
  hasDefValue:false,
  clearRepeatFlag:unref(props).clearRepeatFlag,
  clearRepeatField: unref(props).clearRepeatField,
}, params);

const {vuex} = useVuexState({sectionConfig: props, vuexProps: ['showCtl', 'disabled', CtlComEnum.DEFAULT_SET]});
//当前用户的角色配置权限信息 供按钮控制显示隐藏与禁用（未命中配置默认显示且可编辑；newFieldName 与当前名称不一致时替换按钮文案）
const {roleAclDisplayFlag,roleAclDisabledFlag,roleAclLabel}=usePageRoleAcl({props});
const {elCtlStyle} = useCtlStyle({
  styles,
  props,
  propsStyl: ['width'],
  outExtendProp: unref(pItem)==='xmForm'?['marginLeft','marginTop', 'marginRight', 'marginBottom', 'paddingLeft']:[]
});
const {clickEvent} = useComEvent({events});

const winVisible=ref(false);
const openImportWin = () => {
  winVisible.value=true;
}


</script>

<style type="text/css" lang="less">
.xmImportDataBtn{
  display: flex;
}
</style>
